import { Injectable } from '@angular/core';
import { UserSettings } from 'src/app/models/local/user-settings';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  private static readonly settingsStorageKey = 'pmt_user_settings';

  private userSettings: UserSettings;

  constructor() {
    const userSettingsString = localStorage.getItem(
      UserSettingsService.settingsStorageKey
    );
    if (userSettingsString) {
      this.userSettings = JSON.parse(userSettingsString);
    } else {
      this.userSettings = new UserSettings();
    }
  }

  set filtersPanelPinned(value: boolean) {
    this.userSettings.filtersPanelPinned = value;
    this.saveUserSettings();
  }

  get filtersPanelPinned(): boolean {
    return this.userSettings.filtersPanelPinned;
  }

  set workItemsPanelPinned(value: boolean) {
    this.userSettings.workItemsPanelPinned = value;
    this.saveUserSettings();
  }

  get workItemsPanelPinned(): boolean {
    return this.userSettings.workItemsPanelPinned;
  }

  set setupProcessCountryFilter(value: string[]) {
    this.userSettings.setupProcessCountryFilter = value;
    this.saveUserSettings();
  }

  get setupProcessCountryFilter(): string[] {
    return this.userSettings.setupProcessCountryFilter;
  }

  private saveUserSettings(): void {
    const userSettingsString = JSON.stringify(this.userSettings);
    localStorage.setItem(
      UserSettingsService.settingsStorageKey,
      userSettingsString
    );
  }
}
